import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ChevronDown } from 'lucide-react';
import { useSelector } from 'react-redux';
import { getFileUrl } from '../../utils/helper';
import { Link } from 'react-router-dom';
import { CONTACT_ROUTE } from '../../routes/web/rootRoutes';

function TeamAndFAQ() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = useSelector(
    (state) => state?.globalState?.siteSetting?.faqs || []
  );

  const teams = useSelector(
    (state) => state?.globalState?.siteSetting?.teams || {}
  );

const totalItems = Object.values(teams).reduce((sum, arr) => sum + arr.length, 0);

  
  const departmentOrder = ['A', 'B', 'C', 'D', 'all'];

  useEffect(() => {
    AOS.init({ once: true, duration: 800, easing: 'ease-out-cubic' });
  }, []);

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="bg-gray-50">

      {totalItems > 0 && (
        <section className="py-12 md:py-20">
          <div className="max-w-7xl mx-auto px-4">

            <div className="text-center mb-12 md:mb-16" data-aos="fade-up">
              <span className="inline-block px-4 py-1.5 bg-gradient-to-r from-blue-800 to-blue-600 text-white text-sm font-semibold rounded-full mb-4">
                Leadership
              </span>
              <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
                Meet Our Team
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Dedicated professionals leading DHADAKKAMGARFILMUNION
              </p>
            </div>

            {departmentOrder.map((key) => {
              const members = teams[key] || [];
              if (!members.length) return null;

              const isLessThanFour = members.length < 4;

              return (
                <div
                  key={key}
                  className={`mb-12 ${
                    isLessThanFour
                      ? 'flex flex-wrap justify-center gap-4'
                      : 'grid grid-cols-2 md:grid-cols-4 gap-4'
                  }`}
                >
                  {members.map((item, index) => {
                    const member = item.team ?? item;

                    return (
                      <div
                        key={member?.id || index}
                        data-aos="fade-up"
                        data-aos-delay={index * 100}
                        className="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden w-full md:w-72"
                      >
                        <div className="relative overflow-hidden">
                          <img
                            src={getFileUrl(member?.image, 'section')}
                            alt={member?.title || ''}
                            className="w-full h-40 md:h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition" />
                        </div>

                        <div className="p-4 text-center">
                          <h3 className="text-sm md:text-lg font-bold text-gray-900">
                            {member?.title}
                          </h3>
                          <p className="text-blue-700 font-semibold text-xs md:text-sm mb-2">
                            {member?.link}
                          </p>
                          <p className="text-gray-600 text-sm">
                            {member?.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </section>
      )}

      {/* ================= FAQ SECTION ================= */}
      {faqs.length > 0 && (
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4">

            <div className="text-center mb-12" data-aos="fade-up">
              <span className="inline-block px-4 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-semibold rounded-full mb-4">
                Help Center
              </span>
              <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
                Frequently Asked Questions
              </h2>
            </div>

            <div className="space-y-4">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden"
                >
                  <button
                    onClick={() => toggleFAQ(faq.id)}
                    className="w-full px-6 py-5 flex justify-between items-center text-left"
                  >
                    <span className="font-semibold text-gray-900">
                      {faq.question}
                    </span>
                    <ChevronDown
                      className={`text-blue-600 transition-transform ${
                        openFAQ === faq.id ? 'rotate-180' : ''
                      }`}
                    />
                  </button>

                  <div
                    className={`px-6 pb-5 text-gray-600 transition-all duration-300 ${
                      openFAQ === faq.id ? 'block' : 'hidden'
                    }`}
                  >
                    {faq.description}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <Link
                to={CONTACT_ROUTE}
                className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-800 to-blue-600 text-white font-semibold rounded-full shadow hover:shadow-xl transition"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default TeamAndFAQ;
